import { Component, h } from "@stencil/core";

/**
 * @name      f-footer
 * @type      organism
 *
 * @description
 * representation of Footer
 */
@Component({
  tag: "f-footer",
  styleUrl: "f-footer.scss",
  shadow: true,
})
export class Footer {
  render() {
    return (
      <footer class="o-footer">
        <div class="l-page-row">
          <div class="o-footer__top">
            <div class="o-footer__claim">
              <slot name="footer-claim" />
            </div>
            <slot name="footer-language-selector" />
            <ul class="o-footer__links">
              <slot name="footer-top-links" />
            </ul>
            <div class="o-footer__share">
              <slot name="footer-social-links" />
            </div>
          </div>
          <f-divider />
          <div class="o-footer__bottom">
            <ul class="o-footer__links">
              <slot name="footer-bottom-links" />
            </ul>
            <div class="o-footer__copyright">
              <slot name="footer-copyright" />
            </div>
            <div class="o-footer__back-to-top">
              <f-back-to-top></f-back-to-top>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
